import { createTheme } from '@mui/material/styles'
import { WorkorderStatus } from '../types/serviceRequest'

declare module '@mui/material/styles' {
    interface Palette {
        [WorkorderStatus.ASSIGNED]: Palette['primary']
        [WorkorderStatus.IN_PROGRESS]: Palette['primary']
        [WorkorderStatus.PAUSE]: Palette['primary']
        [WorkorderStatus.COMPLETE]: Palette['primary']
        [WorkorderStatus.APPROVED]: Palette['primary']
        [WorkorderStatus.PRE_APPROVED]: Palette['primary']
        [WorkorderStatus.GO_BACK]: Palette['primary']
        [WorkorderStatus.INVOICED]: Palette['primary']
        white: Palette['primary']
        lightgrey: Palette['primary']
    }
    interface PaletteOptions {
        [WorkorderStatus.ASSIGNED]: PaletteOptions['primary']
        [WorkorderStatus.IN_PROGRESS]: PaletteOptions['primary']
        [WorkorderStatus.PAUSE]: PaletteOptions['primary']
        [WorkorderStatus.COMPLETE]: PaletteOptions['primary']
        [WorkorderStatus.APPROVED]: PaletteOptions['primary']
        [WorkorderStatus.PRE_APPROVED]: PaletteOptions['primary']
        [WorkorderStatus.GO_BACK]: PaletteOptions['primary']
        [WorkorderStatus.INVOICED]: PaletteOptions['primary']
        white: PaletteOptions['primary']
        lightgrey: PaletteOptions['primary']
    }
}

export const defaultTheme = createTheme({
    palette: {
        primary: {
            main: '#46b083',
            contrastText: '#f4f7f6',
            light: '#CDE9DD',
            dark: '#008C85',
        },
        secondary: { main: '#ff7459', contrastText: '#f4f7f6' },
        error: { main: '#e73535', contrastText: '#f4f7f6' },
        warning: { main: '#e0c23a', contrastText: '#f4f7f6' },
        white: { main: '#ffffff' },
        [WorkorderStatus.ASSIGNED]: {
            main: '#9e9e9e',
            contrastText: '#f4f7f6',
        },
        [WorkorderStatus.IN_PROGRESS]: {
            main: '#ffbf00',
            contrastText: '#f4f7f6',
        },
        [WorkorderStatus.PAUSE]: { main: '#9e9e9e' },
        [WorkorderStatus.COMPLETE]: {
            main: '#46b083',
            contrastText: '#f4f7f6',
        },
        [WorkorderStatus.PRE_APPROVED]: { main: '#016fb9' },
        [WorkorderStatus.APPROVED]: { main: '#016fb9' },
        [WorkorderStatus.GO_BACK]: { main: '#ff7459', contrastText: '#f4f7f6' },
        [WorkorderStatus.INVOICED]: { main: '#38f5ff' },
        lightgrey: { main: '#c2c2c2' },
    },
})
